import { render, staticRenderFns } from "./SocketIoClient.vue?vue&type=template&id=3ba1dba4"
import script from "./SocketIoClient.vue?vue&type=script&lang=js"
export * from "./SocketIoClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports